import React from 'react';
import { Form, Input, Button, Switch } from 'antd';
import { useNavigate } from 'react-router-dom';
import AdminLayout from "@/components/layout/admin/adminLayout";
import { URLS } from "@/lib/urls";
import { gradeApi } from "@/api/grade";
import ApiHandleSuccessMessage, {
    ApiHandleErrorMessage
} from "@/lib/helper/apiHandleResultMessage";
import {sprintf} from "@/lib/utils/sprintf";

const { TextArea } = Input;

function AdminGradeCreatePage() {
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const { mutate, isPending } = gradeApi.useAdminCreateGrade();

    const handleSubmit = (values) => {
        mutate(
            {
                ...values,
            },
            {
                onSuccess: (res) => {
                    ApiHandleSuccessMessage(res);
                    navigate(sprintf(URLS.admin.grade.edit, {id: res?.data?.data?.id}));
                },
                onError: (err) => {
                    ApiHandleErrorMessage(err);
                }
            }
        );
    };

    return (
        <AdminLayout
            pageTitle="ایجاد مقطع تحصیلی"
            backTo={URLS.admin.grade.list}
        >
            <div className="w-full p-4 sm:p-6">
                <div className="mx-auto w-full max-w-3xl rounded-xl border border-gray-200 dark:border-gray-700 p-4 shadow-sm sm:p-6 md:p-8">

                    <div className="mb-6">
                        <h2 className="text-lg font-bold sm:text-xl">
                            ایجاد مقطع تحصیلی جدید
                        </h2>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        autoComplete="off"
                        initialValues={{
                            signup: true,
                        }}
                    >
                        <Form.Item
                            label="عنوان مقطع تحصیلی"
                            name="title"
                        >
                            <Input
                                size="middle"
                                placeholder="عنوان مقطع تحصیلی"
                                className="!rounded-lg"
                            />
                        </Form.Item>

                        <Form.Item
                            label="توضیحات"
                            name="desc"
                        >
                            <TextArea
                                rows={5}
                                placeholder="توضیحات مقطع تحصیلی را وارد کنید..."
                                className="!rounded-lg"
                            />
                        </Form.Item>

                        <Form.Item
                            label="وضعیت ثبت‌نام"
                            name="signup"
                            valuePropName="checked"
                        >
                            <Switch
                                checkedChildren="باز"
                                unCheckedChildren="بسته"
                            />
                        </Form.Item>

                        <div className="flex flex-col-reverse gap-3 border-t dark:border-gray-700 pt-5 sm:flex-row sm:justify-end">

                            <Button
                                type="primary"
                                htmlType="submit"
                                size="middle"
                                loading={isPending}
                                className="!rounded-lg"
                            >
                                ایجاد مقطع تحصیلی
                            </Button>

                        </div>
                    </Form>
                </div>
            </div>
        </AdminLayout>
    );
}

export default AdminGradeCreatePage;